import { inject, Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { FilesizePipe } from './filesize.pipe'
import { ToastService } from './toast.service'
import { getFileExtension } from './utils'

@Injectable({
  providedIn: 'root',
})
export class FileValidationService {
  private toastService = inject(ToastService)
  private translateService = inject(TranslateService)
  private fileSizePipe = new FilesizePipe()

  validateFile(file: File, acceptedTypes: string[], maxSize: number | null): boolean {
    const extension = getFileExtension(file)

    if (!acceptedTypes.includes(extension)) {
      const fileTypes = acceptedTypes.map((type) => type.toUpperCase()).join(', ')
      const error = this.translateService.instant('CALLS.CALL_INFO.DOCUMENT_UPLOAD.INVALID_FILE_TYPE', { fileTypes })
      this.toastService.showRaw(error)
      return false
    }
    if (maxSize !== null && file.size > maxSize) {
      const error = this.translateService.instant('CALLS.CALL_INFO.DOCUMENT_UPLOAD.FILE_TOO_LARGE', {
        maxSize: this.fileSizePipe.transform(maxSize),
      })
      this.toastService.showRaw(error)
      return false
    }
    return true
  }

  validateFiles(files: File[], acceptedTypes: string[], maxSize: number | null): File[] {
    return files.filter((file) => this.validateFile(file, acceptedTypes, maxSize))
  }
}
